// Recursive board styling. Properties that have direct opal utility-class
// equivalents (flex, items-center, w-full, m-0, font-light/medium/bold) are
// applied at the JSX site instead. What lives here is pseudo-state behaviour
// (`:hover`, `:focus-visible`, `:last-child`), child combinators, and design
// tokens that don't have utilities (custom dim/* spacing, neutral borders,
// the `__selected` left bar).
const boardStyles = (theme) => ({
  '& .__header-wrapper': {
    borderRadius: 'var(--border-radius-lg)',
    background: 'var(--color-neutral-100)',
    border: 'var(--border-neutral-thin)',
    padding: 'var(--dim-4)',
    gap: 'var(--dim-2)'
  },

  '& .__header': {
    flex: '1 0 auto',
    padding: theme.layout.padding.p5,
    gap: theme.layout.gap.g10,
    fontSize: '22px'
  },

  '& .__group': {
    paddingLeft: theme.layout.padding.p10,
    gap: 'var(--dim-4)',
    minHeight: '3em',
    minWidth: '350px',
    fontSize: 'var(--font-size-md)'
  },

  '& .__group-wrapper': {
    border: 'var(--border-neutral-thin)',
    boxShadow: theme.layout.shadow.light,
    borderRadius: 'var(--border-radius-md)',
    marginBottom: '10px',
    background: 'var(--color-surface-100)',
    '&.__selected': {
      outline: '2px solid var(--color-primary-400)'
    },
    '& .__summary-content': { margin: 0 },
    '& .__summary-root': { paddingLeft: 0 },
    '& .__summary-root-expanded': {
      minHeight: '48px',
      paddingLeft: 0,
      paddingRight: 0
    },
    '& .__details-root': {
      boxShadow: '0px 3px 3px rgba(0, 0, 0, .1) inset',
      padding: 0
    }
  },

  '& .__detail': {
    gap: '10px',
    minHeight: '40px',
    padding: 'var(--dim-3) var(--dim-4)',
    borderTop: 'var(--border-neutral-thin)',
    cursor: 'pointer',
    transition: 'background-color 150ms ease',
    outline: 'none',
    '&:hover': {
      backgroundColor: 'var(--color-neutral-100)'
    },
    '&:focus-visible': {
      outline: '2px solid var(--color-primary-300)',
      outlineOffset: '-2px'
    },
    '&:last-child': {
      borderBottomLeftRadius: 'var(--border-radius-md)',
      borderBottomRightRadius: 'var(--border-radius-md)'
    },
    '&.__selected': {
      background: 'var(--color-surface-300)',
      position: 'relative',
      '&::before': {
        content: '""',
        background: 'var(--color-primary-500)',
        width: '4px',
        height: '100%',
        position: 'absolute',
        left: 0,
        top: 0
      }
    }
  },

  '& .__detail .__name-main': {
    fontWeight: 500,
    wordBreak: 'normal',
    fontSize: 'var(--font-size-sm)'
  },

  '& .__accordion': {
    paddingRight: 0,
    background: 'none',
    boxShadow: 'none',
    '& .Mui-expanded': { margin: 0 }
  }
})

export default boardStyles
